import styles from "./Akademis.module.css"
import React from "react"
import { Card } from "antd"

// Logo line 1
import USS from "./Akademis-img/USS.png"
import ITB from "./Akademis-img/ITB.png"
import unriyo from "./Akademis-img/Unriyo.png"
import himikan from "./Akademis-img/Himikan-univPadjajaran.jpeg"
import IPB from "./Akademis-img/IPB.png"
import undip from "./Akademis-img/undip.png"
import himasuper from "./Akademis-img/himasuperindo.png"
import upnv from "./Akademis-img/upnv.png"
import unpad from "./Akademis-img/UNPAD.png"
import malahayati from "./Akademis-img/UMalahayati.png"
// Logo line 2
import uph from "./Akademis-img/UPH.png"
import unbarw from "./Akademis-img/UNBARW.png"
import itera from "./Akademis-img/ITERA.png"
import uinj from "./Akademis-img/UINJakarta.png"
import haluoleo from "./Akademis-img/universitas-halu-oleo.png"
import awk from "./Akademis-img/universitas-kristen-awk.png"
import polatip from "./Akademis-img/PolitektikatiPadang.png"
import uai from "./Akademis-img/UAI-transparent.png"
import tarakan from "./Akademis-img/univ-tarakan-borneo.png"
import umrah from "./Akademis-img/UMRAH.png"

import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/autoplay"
import { Autoplay } from "swiper/modules"

const Akademis = () => {
  const allLogos = [
    USS, ITB, unriyo, himikan, IPB, undip, himasuper, upnv, unpad, malahayati,
  ]
  const allLogos2 = [
    uph, unbarw, itera, uinj, haluoleo, awk, polatip, uai, tarakan, umrah,
  ]

  return (
    <>
      <div className="top" data-aos="fade-up">
        <h1 className={styles.tittle}>Partner Akademik Kami</h1>
        <p className={styles.text}>
          Mindo Education aktif bekerja sama dengan perguruan tinggi di seluruh
          Indonesia <br /> 
          dalam menghadirkan pelatihan, seminar, dan program
          pengembangan berbasis <br /> 
          kebutuhan industri
        </p>
      </div>
      <div className={styles.Akademis} data-aos="fade-up">
        {/* line 1 */}
        <Swiper
          slidesPerView={5}
          spaceBetween={8}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: false,
          }}
          speed={2000}
          freeMode={true}
          modules={[Autoplay]}
          className="mySwiper"
          breakpoints={{
            0: {
              // 0px ke atas
              slidesPerView: 3,
            },
            601: {
              // 601px ke atas
              slidesPerView: 4,
            },
            835: {
              // 835px ke atas
              slidesPerView: 5,
            },
          }}>
          {allLogos.map((logo, index) => (
            <SwiperSlide key={`row1-${index}`}>
              <Card size="small" className={styles.cardLogo}>
                <img
                  src={logo}
                  alt={`logo-${index}`}
                  className={styles.logoAkademis}
                />
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* line 2 */}
        <Swiper
          slidesPerView={5}
          spaceBetween={8}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: false,
          }}
          speed={2000}
          freeMode={true}
          modules={[Autoplay]}
          className={`mySwiper swiper-row2`}
          breakpoints={{
            0: {
              // 0px ke atas
              slidesPerView: 3,
            },
            601: {
              // 601px ke atas
              slidesPerView: 4,
            },
            835: {
              // 835px ke atas
              slidesPerView: 5,
            },
          }}>
          {allLogos2.map((logo, index) => (
            <SwiperSlide key={`row2-${index}`}>
              <Card size="small" className={styles.cardLogo}>
                <img
                  src={logo}
                  alt={`logo-${index}`}
                  className={styles.logoAkademis}
                />
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  )
}

export default Akademis
